module.exports = __webpack_public_path__ + "static/media/gen_img17.cd7c014e.png";